import {
  createMuiTheme,  
} from '@material-ui/core/styles';

const AppTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#029AB1',
    },
    secondary: { main: '#26A69A'},
  },
});

export default AppTheme;